<script>
    import { HStack, VStack, Spacer, Fixed, MediaQuery } from "./layout";
    import { Icon, Button, Label, Checkbox } from "./widget";
    import { navigate } from "../router";
    import { count } from "../rsvp.js";

    export let guid;

    let current = null;
    let notifyByEmail = false;

    function update(notifyByEmail) {
        console.log("updating", notifyByEmail);
    }

    $: update(notifyByEmail);

    const doit = () => navigate(`#/rsvp/${guid}`);
</script>

<article>
    <MediaQuery query="(min-width: 481px)">
        <VStack alignment="stretch">
            <HStack>
                <Spacer />
                <Label
                    text="Messages reçus"
                    icon="comment"
                    iconLeft={false}
                    size="18"
                    iconColor="var(--primary-light-color)" />
                <Spacer />
            </HStack>
            <HStack>
                <Spacer />
                {#await count(guid) then messages}
                    <VStack>
                        <div>
                            Vous avez<span class="value">{messages[0].count}</span> messages
                        </div>
                        <button class="primary" on:click={doit}>Voir</button>
                    </VStack>
                {/await}
                <Spacer />
            </HStack>
            <HStack>
                <Spacer>
                    <Checkbox id={"notifyByEmail"} bind:value={notifyByEmail} bind:current>
                        <span>Activer les notifications</span>
                    </Checkbox>
                </Spacer>
            </HStack>
        </VStack>
    </MediaQuery>
    <MediaQuery query="(max-width: 480px)">
        <Button action={doit}>
            <HStack alignment="center">
                <img src="/images/ic_coeurVertx4.png" alt="RSVP" width="48px" />
                <span>Messages reçus</span>
                <Spacer />
                <Icon name="chevron-right" />
                <Fixed />
            </HStack>
        </Button>
    </MediaQuery>
</article>

<style>
    article {
        width: 100%;
        min-height: 48px;
        background-color: white;
        margin-top: 5px;
        padding-top: 5px;
    }
    span {
        margin-left: 1em;
    }
    @media (min-width: 481px) {
        article {
            padding: 1em;
            width: fit-content;
            min-width: 200px;
        }
        span {
            font-size: small;
            line-height: 2em;
        }
        span.value {
            color: var(--secondary-light-color);
            margin-left: 0.5em;
            font-size: large;
            font-weight: bold;
        }
    }
</style>
